import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

//constants

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-formheader',
  templateUrl: './FormHeader.component.html'
})
export class FormHeaderComponent implements OnInit {

  
  @Input() public title: string;
    @Input() public form: FormGroup;

    constructor() 
    { 
    }


    ngOnInit(): void {
    }

}